// extracted by mini-css-extract-plugin
export default {"price":"d--z","onSale":"e--z","msrpLabelPrice":"f--z","msrpLabel":"g--z","originalPrice":"h--z","percentOff":"i--z"};